export const SUBSTANCES = "Sostanze / Riduzione del danno";

export const GROUPS = [
  { key: "Non monogame", label: "Persone non monogame" },
  { key: "Neurodivergenti", label: "Persone neurodivergenti" },
  { key: "Gay", label: "Persone gay" },
  { key: "BDSM/Kinky", label: "BDSM/Kinky" },
  { key: "Intersessuali", label: "Persone intersessuali" },
  { key: "Ace/Aro", label: "Persone ace/asessuali/aromantiche" },
  { key: "Trans", label: "Persone trans (binarie e non binarie)" },
  { key: "Cross-dresser", label: "Persone cross-dresser" },
  { key: "Lesbiche", label: "Persone lesbiche" },
  { key: "Bi/Pan", label: "Persone bisessuali/pansessuali" },
  { key: "Disabili", label: "Persone disabili" },
  { key: "BIPOC", label: "Persone razzializzate/BIPOC" },
  { key: "Persone grasse", label: "Persone grasse (no body positivity mainstream)" },
  { key: "Questioning", label: "Persone questioning" },
  { key: "Sex workers", label: "Sex workers" },
  { key: SUBSTANCES, label: "Persone che usano sostanze / riduzione del danno", isNew: true },
];

export const OPTIONS = {
  pronomi: ["He/him (maschili)", "She/her (femminili)", "They/them (neutri)"],
  qualifica: ["Psicologǝ", "Psicoterapeuta", "Neuropsicologǝ", "Medico (Psichiatra, Ginecologǝ, ecc.)", "Consulente sessuale", "Sessuologǝ", "Avvocatǝ"],
  trauma: ["sì", "più sì che no", "più no che sì", "no"],
  eta: ["infanti", "adolescenti", "giovani adulti", "persone adulte", "terza età", "qualsiasi età"],
  lavoro_con: ["Singoli", "Coppie/diadi", "Triadi/Polecole", "Famiglie"],
  lingua: ["italiana", "inglese", "spagnola", "francese", "tedesca", "portoghese", "araba", "cinese", "giapponese", "rumena", "russa", "Lingua dei segni (italiana)"],
  formed: ["sì", "più sì che no", "più no che sì", "no"],
  in_studio: ["disponibile e accessibile", "disponibile ma non accessibile", "non disponibile"],
  tempi: ["lista d'attesa piena fino a data da destinarsi", "attesa di qualche mese", "attesa di qualche settimana", "disponibile da subito", "contattare direttamente lǝ professionistǝ"],
};

export const EMPTY_FORM = {
  cognome: "", nome: "", pronomi: [], qualifica: [], specifiche: "", trauma: "",
  eta: [], lavoro_con: [], lingua: [], friendly: {}, formed: {},
  city: "", in_studio: "", online: null, tempi: "", agevolate: "",
  email: "", whatsapp: "", telegram: "", instagram: "", facebook: "", sito: "", altro: "",
};

export const FIELD_LABELS = {
  cognome: "Cognome", nome: "Nome", pronomi: "Pronomi", qualifica: "Qualifica professionale",
  specifiche: "Specifiche sulla qualifica", trauma: "Formazione sul trauma", eta: "Età dell'utenza",
  lavoro_con: "Lavoro con", lingua: "Lingue di lavoro", friendly: "Friendly", formed: "Formed",
  city: "Città", in_studio: "Disponibilità in studio", online: "Disponibilità online", tempi: "Tempistiche",
  agevolate: "Tariffe agevolate", email: "E-mail", whatsapp: "WhatsApp", telegram: "Telegram",
  instagram: "Instagram", facebook: "Facebook", sito: "Sito", altro: "Altro da segnalare",
};

const REQUIRED_TEXT = ["cognome", "nome", "specifiche", "city", "agevolate", "email", "whatsapp", "telegram", "instagram", "facebook", "sito"];
const REQUIRED_LIST = ["pronomi", "qualifica", "eta", "lavoro_con", "lingua"];
const REQUIRED_CHOICE = ["trauma", "in_studio", "tempi"];

export function validate(f) {
  const errors = {};
  REQUIRED_TEXT.forEach((k) => { if (!String(f[k] || "").trim()) errors[k] = "Campo obbligatorio"; });
  REQUIRED_LIST.forEach((k) => { if (!f[k].length) errors[k] = "Seleziona almeno un'opzione"; });
  REQUIRED_CHOICE.forEach((k) => { if (!OPTIONS[k].includes(f[k])) errors[k] = "Seleziona un'opzione"; });
  if (f.online === null) errors.online = "Seleziona un'opzione";
  if (f.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(f.email)) errors.email = "Email non valida";
  const base = GROUPS.filter((g) => !g.isNew);
  if (base.some((g) => typeof f.friendly[g.key] !== "boolean")) errors.friendly = "Rispondi sì o no per ogni gruppo";
  if (base.some((g) => !f.formed[g.key])) errors.formed = "Indica un livello per ogni gruppo";
  const ordered = {};
  Object.keys(FIELD_LABELS).forEach((k) => { if (errors[k]) ordered[k] = errors[k]; });
  return ordered;
}

export const toPayloadFormed = (formed) => Object.fromEntries(Object.entries(formed).filter(([, v]) => v));
